import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { routerActions } from 'react-router-redux'
import { getTimezoneDate } from 'utils/date'

import * as R from 'ramda'
import Moment from 'moment'
import Deleted from 'components/Deleted'

import { doc, dirtyRead } from 'selectors/common'
import { leases } from 'selectors/entities'
import { lastTenantLease } from 'selectors/leases'

import dataActions from 'actions/dataActions'

let select = dirtyRead(
	(state, props) => ({
		lastTenantLease: lastTenantLease(state, props)
	})
)

export class LastLease extends Component{
	render(){
		let {props} = this
		let activeLeases = props.lastTenantLease
		return(
			<div className="lease" style={{marginTop:"10px"}}>
				{activeLeases && activeLeases._id?
					<div>
						<Link
							to={`/landlord/lease/${activeLeases._id}/`}
							style={{
								textDecoration: 'none'
							  , color: 'inherit'
							}}
						>
							<svg
								width="20px"
								height="20px"
								viewBox="0 0 63 66"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
								style={{
									width: "18px"
								  , height: "18px"
								  , float: "left"
								  , marginRight: "20px"
								  , position: "relative"
								  , display: ""
								}}
							>
								<title>leases</title>
								<defs></defs>
								<g id="Page-1" stroke="none" strokeWidth="0.2" fill="none" fillRule="evenodd">
									<g id="leases" fill="#3cd2ae">
										<path d="M0,9 L5,9 L5,64.5 C5,65.328 5.672,66 6.5,66 L7.469,66 C7.866,66 8.248,65.842 8.53,65.561 L13.334,60.757 L18.138,65.561 C18.418,65.842 18.8,66 19.197,66 L19.468,66 C19.865,66 20.247,65.842 20.529,65.561 L25.333,60.757 L30.137,65.561 C30.418,65.842 30.8,66 31.197,66 L31.468,66 C31.865,66 32.247,65.842 32.529,65.561 L37.333,60.757 L42.137,65.561 C42.418,65.842 42.8,66 43.197,66 L43.468,66 C43.865,66 44.247,65.842 44.529,65.561 L49.333,60.757 L54.137,65.561 C54.418,65.842 54.8,66 55.197,66 L56.5,66 C57.328,66 58,65.328 58,64.5 L58,9 L63,9 L63,0 L0,0 L0,9 L0,9 Z M55,62.182 L50.394,57.576 C49.808,56.99 48.859,56.99 48.273,57.576 L43.334,62.515 L38.395,57.576 C38.102,57.283 37.718,57.137 37.334,57.137 C36.95,57.137 36.566,57.283 36.273,57.576 L31.334,62.515 L26.395,57.576 C25.809,56.99 24.86,56.99 24.274,57.576 L19.335,62.515 L14.396,57.576 C13.81,56.99 12.861,56.99 12.275,57.576 L8,61.848 L8,9 L55,9 L55,62.182 L55,62.182 Z" id="Shape"></path>
										<rect id="Rectangle-path" x="11" y="14" width="29" height="3"></rect>
										<rect id="Rectangle-path" x="11" y="23" width="23" height="3"></rect>
										<rect id="Rectangle-path" x="11" y="33" width="29" height="3"></rect>
										<rect id="Rectangle-path" x="11" y="43" width="29" height="3"></rect>
									</g>
								</g>
							</svg>
						</Link>
						<p style={{fontSize: "15px", fontWeight:"400", margin: "0"}}>
							<Link
								to={`/landlord/lease/${activeLeases._id}/`}
								style={{
									textDecoration: 'underline'
								  , color: 'inherit'
								  , cursor: "pointer"
								}}
							>
								<span>
									Lease <span style={{ fontWeight:"bold"}}>${activeLeases.rent}</span> till
									<span style={{ fontWeight:"bold", marginRight:"10px"}}>
										{` ${getTimezoneDate(activeLeases.dateTill).getDate()}/${getTimezoneDate(activeLeases.dateTill).getMonth()+1}/${getTimezoneDate(activeLeases.dateTill).getFullYear()}`}
									</span>
								</span>
							</Link>

						</p>
					</div>
					:
					<p style={{fontSize: "15px", textAlign:"center"}}>
						<span style={{color: "#3cd2ae", cursor: "pointer"}}
							onClick={()=> {
								props.ADD({
								    propertyID: props.propertyID
								  , type: "lease"
				  			      , date: Moment(new Date()).format('YYYY-MM-DD')
				  				  , dateFrom: Moment(new Date()).add("1", "day").format("YYYY-MM-DD")
				  				  , dateTill: Moment(new Date()).add("1", "year").format("YYYY-MM-DD")
								})
							}}

						>
							<svg
								width="16px"
								height="16px"
								viewBox="0 0 24 24"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
								style={{
									verticalAlign: "middle"
								  , marginRight: "5px"
								  , cursor: "pointer"
								}}
							>
									<title>Group 2</title>
									<defs></defs>
									<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
										<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#5ae4c3" strokeWidth="2">
											<path d="M11,4.5 L11,17.5" id="Line" stroke-linecap="square"></path>
											<path d="M5,11 L17,11" id="Line" stroke-linecap="square"></path>
											<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
										</g>
									</g>
							</svg>
							<span style={{fontSize: "13px", borderBottom: "dotted 2px #5ae4c3"}}>NEW LEASE</span>
						</span>
					</p>
				}
			</div>
		)
	}
}

export default connect(select, R.mergeAll([dataActions, routerActions]))(LastLease)



// WEBPACK FOOTER //
// ./src/routes/landlord/tenantForm/Leases.js